import { ref } from 'vue'

export type Theme = 'system' | 'light' | 'dark'

/** Available theme options, in cycle order. */
export const THEMES: Theme[] = ['system', 'light', 'dark']

const STORAGE_KEY = 'theme'

function read(): Theme {
  const v = localStorage.getItem(STORAGE_KEY)
  return v === 'light' || v === 'dark' ? v : 'system'
}

/** Reflect the theme on <html>: an explicit data-theme for light/dark, none for system. */
function apply(t: Theme): void {
  const root = document.documentElement
  if (t === 'system') delete root.dataset.theme
  else root.dataset.theme = t
}

const theme = ref<Theme>(read())

// Apply immediately at module load (before mount) to avoid a flash of the wrong theme.
apply(theme.value)

export function setTheme(t: Theme): void {
  theme.value = t
  localStorage.setItem(STORAGE_KEY, t)
  apply(t)
}

export function useTheme() {
  return { theme, setTheme, THEMES }
}

export { theme }
